import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR, NgForm } from '@angular/forms';
import { AppTextService } from '@fi-shared/app-text';
import { ControlValueAccessorBase } from '@fi-shared/control-value-accessor-validator-base';

@Component({
    selector: 'fi-checklist-edit-checkpoint-select-role-to-notify',
    templateUrl: './checkpoint-select-role-to-notify.component.html',
    styleUrls: ['./checkpoint-select-role-to-notify.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: ChecklistEditCheckpointSelectRoleToNotifyComponent,
            multi: true,
        },
    ],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: NgForm,
        },
    ],
    standalone: false,
})
export class ChecklistEditCheckpointSelectRoleToNotifyComponent extends ControlValueAccessorBase<number> {
    @Input() roles: Array<any>;
    @Input() placeholder?: string;
    @Input() hidePlaceholderOnSelectRole?: boolean;

    constructor(private appTextService: AppTextService) {
        super();
    }

    getPlaceholder() {
        if (this.hidePlaceholderOnSelectRole && this.ngModel) return undefined;
        const textId = this.placeholder || 'checklist.notify_on_deviation';
        return this.appTextService.get(textId);
    }
}
